// extracted by mini-css-extract-plugin
export default {"deviceControlContainer":"device-control_deviceControlContainer__ccmFa"};